import { useNavigate, useParams } from "react-router-dom";
import { atom, useAtom } from "jotai";

import { T } from "@repo/transifex";
import { getErrorMessage } from "@repo/system";
import { useTill } from "~/api/tills/hooks/use-till";
import { useAppContext } from "~/providers/app";
import { Button, DialogError, DialogLoading } from "~/components";
import { useOpenSession } from "~/api/sessions/hooks/use-open-session";
import { getAuth } from "~/providers/store/auth";

export const startedCashBalanceAtom = atom(0);

export const HeaderButtonOpenSession = () => {
  const navigate = useNavigate();

  const { profileId } = getAuth();
  const { tillId } = useParams();

  const {
    hardware: { printer }
  } = useAppContext();

  const { mutate: createTillSession, status, error } = useOpenSession();
  const { data: till, status: tillStatus } = useTill(tillId);

  const [startedCashBalance, setStartedCashBalance] = useAtom(
    startedCashBalanceAtom
  );

  if (tillStatus !== "success") return null;

  const handleConfirm = () => {
    if (!profileId) {
      throw new Error("Profile not selected");
    }

    createTillSession(
      {
        deviceId: till.deviceId ?? "",
        printerId: printer?.identifier ?? "",
        tillId: till.id,
        startedCashBalance,
        currency: till.currency,
        profileId
      },
      {
        onSuccess: () => {
          setStartedCashBalance(0);
          navigate("/settings/tills");
        }
      }
    );
  };

  return (
    <>
      <Button className="ml-auto" onClick={handleConfirm} variant="primary">
        <T _str="Open register" />
      </Button>

      {status === "pending" && <DialogLoading />}
      {status === "error" && (
        <DialogError
          backUrl={tillId ? `settings/tills/${tillId}` : "settings/tills"}
          error={getErrorMessage(error)}
        />
      )}
    </>
  );
};
